import { Model } from "src/engine/modules/model/classes"
import memoize from "lodash/memoize"

const entityName = `planResourcesTypes`

export default memoize(
  planId =>
    new Model({
      name: entityName,
      getRestUrn: () => `/plans/${planId}/resources/types`,
      primaryKey: `id`,
    }),
)
